import { render } from "./download.vue?vue&type=template&id=7bf51dfc&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=7bf51dfc&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf51dfc"]])

export default __exports__